import { Col, Row, useTheme } from '@teko/ds-desktop';
import { HomeLocationColored, PenColored } from '@teko/ds-icon';
import { styled } from '@teko/ui';
import React from 'react';
import { t } from 'i18n';
import { TerminalPickerItem } from './TerminalPickerItem';
import { useDistanceTerminalContext, useTenantConfig } from 'contexts';

export const MiniTerminalPicker = () => {
  const { colors } = useTheme();
  const {
    onOpenTerminalPicker,
    isGetCurrentLocation,
    locationGetDistanceTerminals,
    currentTerminals = [],
    currentTerminal,
    setNewTerminal,
    setIsModeEnterAddress,
  } = useDistanceTerminalContext();
  const { epicOmni1589 } = useTenantConfig();
  return (
    <Wrapper>
      <Content>
        <Header justify="space-between">
          <Col style={{ width: '70%' }}>
            <Row justify="start">
              <HomeLocationColored size={20} />
              <Title style={{ marginLeft: 4 }}>{t('Khu vực giao hàng')}</Title>
            </Row>
            {!isGetCurrentLocation && (
              <SubTitle>
                {locationGetDistanceTerminals?.address},{' '}
                {locationGetDistanceTerminals?.wardName},{' '}
                {!epicOmni1589
                  ? `${locationGetDistanceTerminals?.districtName},`
                  : ''}
                {locationGetDistanceTerminals?.provinceName}
              </SubTitle>
            )}
          </Col>
          <Row
            onClick={() => {
              onOpenTerminalPicker?.();
              setIsModeEnterAddress?.(true);
            }}
            style={{ cursor: 'pointer' }}
          >
            <PenColored size={20} />
            <Title
              style={{
                fontWeight: 'initial',
                color: colors.primary,
                marginLeft: 8,
              }}
            >
              {t('Thay đổi')}
            </Title>
          </Row>
        </Header>
        <Body>
          <Title>{currentTerminals?.length} siêu thị gần bạn:</Title>
          {currentTerminals.map((item) => {
            return (
              <TerminalPickerItem
                key={item.terminalId}
                onClick={() => setNewTerminal?.(item)}
                isChoice={currentTerminal?.terminalId === item.terminalId}
                terminalName={item.terminalName}
                distance={item.distance}
                terminalAddress={item.fullAddress}
              />
            );
          })}
        </Body>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  width: 384px;
`;

const Content = styled.div`
  width: 100%;
`;

const Header = styled(Row)`
  width: 100%;
  padding-bottom: 16px;
  border-bottom: 1px solid #0000000f;
  margin-bottom: 16px;
`;

const Body = styled.div`
  width: 100%;
  max-height: 35vh;
  overflow-y: auto;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;

const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const SubTitle = styled.span`
  font-size: 12px;
  font-weight: 400;
`;
